import { render } from "./S960_Konfiguration.vue?vue&type=template&id=2e95457a&ts=true"
import script from "./S960_Konfiguration.vue?vue&type=script&lang=ts"
export * from "./S960_Konfiguration.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__